import axios from 'axios';

import { Scenario } from 'components/types';

import { SCENARIO, SCENARIO_FLEX_CAPACITY_SETTINGS } from '../endpoints';

const composeScenarioQueryParams = ({
  planUnitIds,
  isArchived
}: {
  planUnitIds: number[];
  isArchived: boolean;
}) => {
  const planUnitParams = planUnitIds.reduce((acc, next, idx) => {
    acc += `${idx > 0 ? ',' : '?costCenters='}${next}`;
    return acc;
  }, '');

  return isArchived ? `${planUnitParams}&archived=true` : planUnitParams;
};

type GetScenariosOptions = {
  planUnitIds: number[];
  options?: { isArchived: boolean };
  signal?: AbortSignal;
};
export const getScenariosForPlanUnits = ({
  planUnitIds,
  options = { isArchived: false },
  signal
}: GetScenariosOptions) => {
  const queryParams = composeScenarioQueryParams({
    planUnitIds: planUnitIds.filter((id) => id),
    isArchived: options.isArchived
  });
  return axios.get<Scenario[]>(`${SCENARIO}${queryParams}`, {
    signal
  });
};

export interface CreateScenarioPayload {
  year: number;
  name: string;
  costCenters: { id: number }[];
  scenarioToCopyId?: number | null;
}

interface UpdateScenarioPayload extends CreateScenarioPayload {
  archived?: boolean;
}

export const createNewScenario = (payload: CreateScenarioPayload) =>
  axios.post<Scenario>(SCENARIO, payload);

export const updateScenario = (
  payload: UpdateScenarioPayload,
  scenarioId: number
) => axios.put(`${SCENARIO}/${scenarioId}`, payload);

export const deleteScenario = (id: number) => axios.delete(`${SCENARIO}/${id}`);

export type ScenarioFlexCapacitySettingsResponse = {
  flexCapacity: number;
  flexCapacityBalance: number;
  flexCapacityPercentage: number;
  scenarioId: number;
};

export const getScenarioFlexCapacitySettings = ({
  scenarioId,
  year
}: {
  scenarioId: number;
  year: number;
}) =>
  axios.get<ScenarioFlexCapacitySettingsResponse>(
    SCENARIO_FLEX_CAPACITY_SETTINGS,
    {
      pathParams: { scenarioId, year }
    }
  );

export type UpdateScenarioFlexCapacitySettingsOptions = {
  scenarioId: number;
  year: number;
  payload: {
    flexCapacityPercentage: number;
  };
};
export const updateScenarioFlexCapacitySettings = ({
  scenarioId,
  year,
  payload
}: UpdateScenarioFlexCapacitySettingsOptions) =>
  axios.post(SCENARIO_FLEX_CAPACITY_SETTINGS, payload, {
    pathParams: { scenarioId, year }
  });
